module.exports = __webpack_public_path__ + "images/icons_v2/check-circle-outlined-bbf04ba0.svg";